import { FilterOptionsListAndRules } from './types';
export const conditions = [
  {
    value: '>',
    title: '>',
  },
  {
    value: '<',
    title: '<',
  },
  {
    value: '>=',
    title: '>=',
  },
  {
    value: '<=',
    title: '<=',
  },
  {
    value: '=',
    title: '=',
  },
  {
    value: '!=',
    title: '≠',
  },
];
export const conditionsMapByFieldType: Record<
  Exclude<FilterOptionsListAndRules['conditions'], undefined>,
  typeof conditions
> = {
  all: conditions,
  equal: conditions.slice(-2),
  restOfEqual: conditions.slice(0, -2),
};
